/**
 * Inverted color scheme - dark text on light background in light mode,
 * light text on dark background in dark mode
 */
export const INVERTED_COLOR_STYLES = {
  backgroundColor: 'gray.900',
  color: 'gray.50',
  _dark: {
    backgroundColor: 'gray.50',
    color: 'gray.900',
  },
} as const;

export const TIMESTAMP_BADGE_COLOR_STYLES = {
  color: 'vimeoBlue.700',
  bg: 'vimeoBlue.50',
  _dark: {
    color: 'vimeoBlue.600',
    bg: 'vimeoBlue.900',
  },
} as const;

export const TIMESTAMP_BADGE_LAYOUT_PROPS = {
  paddingInline: '4px',
  borderRadius: '4px',
} as const;

export const MAX_COMMENT_CHARACTERS = 10000;
